module.exports = __webpack_public_path__ + "static/media/everdays-textless-logo.89af9c42.svg";